import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import request from 'lib/request'
import dayjs from 'dayjs'

import config from 'config/app'
import lib from 'lib/commons'
import Spinner from 'components/Spinner'

import {
  getCurrentUser
} from 'authentication/actions'

import Header from './Header'

let checkInterval

class PageLayout extends React.Component {
  constructor(props) {
    super(props)
  }

  static contextTypes = {
    router: PropTypes.object,
  }

  componentDidMount() {
    this.props.getCurrentUser()

    $(window).resize(function() {
      let e = $(window).width();
      e >= 1920 ? $("html").css("font-size", "10px") : e >= 1200 ? $("html").css("font-size", 10 * e / 1920 + "px") : e >= 1100 ? $("html").css("font-size", "10px") : $("html").css("font-size", 10 * e / 1300 + "px")
    })

    $(window).trigger('resize')

    const parsed = queryString.parse(location.search)
    const utm_source = parsed.utm_source
    const garena_token = parsed.garena_token
    let clientLogged = localStorage.getItem('garena_token')
    let checkString = garena_token + dayjs().format('DD-MM-YYYY-mm') + '-ffdaily'

    if(garena_token && checkString != clientLogged && garena_token.length > 80) {
      request(`login/callback?garena_token=${garena_token}&source_type=ingame`).then(function(response) {
        if(response.status == 'successful') {
          localStorage.setItem('garena_token', checkString)
          window.location.reload()
        } else {
          lib.showError(response.error_code)
        }
      })
    }

  }
  
  componentWillReceiveProps(nextProps) {
  }

  componentWillUnmount() {
    clearInterval(checkInterval)
  }

  render() {
    return (
      <React.Fragment>
        <Header
          currentUser={this.props.currentUser}
          />
        <section id="main-body" className={`page-${this.props.location.pathname != '/' ? this.props.location.pathname.replace('/', '') : ''}`}>
          <React.Fragment>
            {this.props.children}
          </React.Fragment>
        </section>
      </React.Fragment>
    )
  }
}
PageLayout.propTypes = {
  children: PropTypes.node,
}

const mapDispatchToProps = {
  getCurrentUser
}

const mapStateToProps = (state) => ({
  location: state.location,
  currentUser: state.currentUser
})

export default connect(mapStateToProps, mapDispatchToProps)(PageLayout)



// WEBPACK FOOTER //
// ./src/layouts/PageLayout/PageLayout.js